export const ORGANIZATION_SET = "ORGANIZATION_SET";
export const SIGN_OUT_COMPLETE = "SIGN_OUT_COMPLETE";
